import {
  FETCH_SCHOOL_STUDENTS_SUCCESS,
  FETCH_SCHOOL_STUDENTS_ASYNC_START,
  FETCH_SCHOOL_STUDENTS_ASYNC_END,
  REMOVE_STUDENT_FROM_SCHOOL_SUCCESS,
} from '../actions/actions'
import dotProp from 'dot-prop-immutable-chain'

export default function school(state = {}, action) {
  switch (action.type) {
    case FETCH_SCHOOL_STUDENTS_ASYNC_START:
      return dotProp(state)
        .set('schoolAsync', true)
        .value()

    case FETCH_SCHOOL_STUDENTS_ASYNC_END:
      return dotProp(state)
        .set('schoolAsync', false)
        .value()

    case FETCH_SCHOOL_STUDENTS_SUCCESS:
      return dotProp(state)
        .set('students', { ...action.students, count: action.count })
        .value()

    case REMOVE_STUDENT_FROM_SCHOOL_SUCCESS:
      const studentToRemoveId = parseInt(action.studentId, 10)
      return dotProp(state)
        .delete(`students.entities.students.${studentToRemoveId}`)
        .set(`students.result`, result =>
          result.filter(studentId => studentId !== studentToRemoveId)
        )
        .value()

    // there is a case which is not handled: add students,
    // state should have a needSync? property, when users are added
    // needSync should be changed to true, then the list page must
    // fetch data in CWM life cycle hook

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/school.js